




















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
	name: 'APIClassProp'
})
export default class APIClassProp extends Vue {
	@Prop(String)
	title: string;

	@Prop(String)
	returnType: string;

	@Prop([String, Object])
	returnTypeLink: string | object;

	@Prop(String)
	tag: string;

	@Prop(String)
	tagType: string;
}
